import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import { re } from 'mathjs';
import Storage from '@/found/utils/storage';
import selectTer from './components/selectTer.vue';
import selectCus from './components/selectCus.vue';
import proDetails from './components/productTable.vue';
// import CashDetailList from './components/cap_scan_list.vue';

formCreate.component('selectTer', selectTer);
formCreate.component('selectCus', selectCus);
formCreate.component('proDetails', proDetails);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      buttons: {
        submitAudit: true,
      },
      buttonText: {
        submitAudit: '暂存',
      },
      rule: [],
      formFunctionCode: 'main_form',
    };
  },
  async created() {
    await this.getFormRule('main_form', 'CRM20250513000000004');
  },
  methods: {
    // 设置规则
    setRule(item) {
      const rowData = item;
      if (rowData.field === 'files') {
        rowData.props = {
          ...rowData.props,
          showFileList: true,
          uploadType: 'file',
          listType: 'text',
          fileMsg: '只能上传pdf/word/excel/ppt/png/jpg文件',
          accept: '.pdf,.docx,.doc,.xlsx,.xls,.ppt,.pptx,.png,.jpg',
        };
      }
      if (rowData.field === 'controlType') {
        rowData.on = {
          ...rowData.on,
          change: (e) => {
            if (e === '1') {
              // 总量控制
              this.setValue({
                isSupplyBill: null,
              });
              this.hiddenFields(true, 'isSupplyBill');
            } else {
              this.hiddenFields(false, 'isSupplyBill');
            }
          },
        };
      }
      if (rowData.field === 'terminalName') {
        rowData.props = {
          ...item.props,
          getValue: (field) => this.getFieldValue(field),
          title: rowData.title,
        };
        rowData.on = {
          ...rowData.on,
          change: (e) => {
            console.log('终端选择', e);
            this.setValue({
              terminalName: { terminalName: e.terminalName, terminalCode: e.terminalCode, licenseFirmName: e.licenseFirmName },
              terminalCode: e.terminalCode,
              licenseFirmName: e.licenseFirmName,
              // cusName: null,
              // cusCode: null,
              companyCode: null,
              companyName: null,
              invoiceType: e.billType,
              // responseName: null,
              // responsePosName: null,
              // principalSubCompanyName: null,
            });
            if (e.billType) {
              this.disabled(true, ['invoiceType']);
            } else {
              this.disabled(false, ['invoiceType']);
            }
          },
        };
      }
      // if (rowData.field === 'cusName') {
      //   rowData.props = {
      //     ...item.props,
      //     getValue: (field) => this.getFieldValue(field),
      //     title: rowData.title,
      //   };
      //   rowData.on = {
      //     ...rowData.on,
      //     change: (e) => {
      //       console.log('经销商选择', e);
      //       console.log(this.getRule('terminalName'));
      //       // this.getRule('responseName').restfulParams = {
      //       //   customerCode: e.customerCode,
      //       // };
      //       this.setValue({
      //         cusName: { customerName: e.customerName, customerCode: e.customerCode },
      //         cusCode: e.customerCode,
      //         companyCode: null,
      //         companyName: null,
      //         responseName: null,
      //         responsePosName: null,
      //         principalSubCompanyName: null,
      //       });
      //     },
      //   };
      // }
      if (rowData.field === 'responseName') {

        // rowData.restful = '/mdm/mdmCustomerMsgExtController/findDockingListByCustomerCodeGet';
        // rowData.restfulParamsGetValue = { customerCode: 'cusCode' };
        // rowData.optionsKey = {
        //   value: 'userName',
        //   label: 'fullName',
        // };
        // rowData.props = {
        //   ...rowData.props,
        //   remote: true,
        //   filterable: true,
        // };
        // rowData.on = {
        //   ...rowData.on,
        //   getItem: (value) => {
        //     console.log('getItem', value);
        //     this.setValue({
        //       responseName: value.fullName,
        //       responseCode: value.userName,
        //       responsePosCode: value.positionCode || '',
        //       responsePosName: value.positionName || '',
        //       principalSubCompanyName: value.ext1 || '',
        //       principalSubCompanyCode: value.ext2 || '',
        //     });
        //   },
        //   change: (value) => {
        //     console.log('getd', value);
        //     this.setValue({ responseCode: value });
        //   },
        //   optionCallback: (e) => {
        //     const cusCode = this.getFieldValue('cusCode');
        //     if (!cusCode) {
        //       rowData.options = [];
        //       this.$message.error('请选择经销商');
        //     }
        //   },
        // };
      }
      if (rowData.field === 'companyCode') {
        const user = Storage.l.get('userInfo') ? JSON.parse(Storage.l.get('userInfo')) : {};
        rowData.props = {
          ...rowData.props,
          filterable: true,
        };
        rowData.on = {
          ...rowData.on,
          getItem: (value) => {
            console.log('cscs', value);
            this.setValue({
              companyName: value.dictValue,
              responseName: user.fullName || '',
              responseCode: user.userName || '',
              responsePosName: user.positionName || '',
              responsePosCode: user.positionCode || '',
            });
            this.getFcompany();
          },
          change: (value) => {
            this.setValue({ companyCode: value });
          },
        };
      }
      if (rowData.field === 'channelCode') {
        rowData.props = {
          ...rowData.props,
        };
        rowData.on = {
          ...rowData.on,
          getItem: (value) => {
            console.log('channelCode', value);
            this.setValue({ channelName: value.dictValue });
          },
          change: (value) => {
            this.setValue({ channelCode: value });
          },
        };
      }
      if (rowData.field === 'details') {
        rowData.props = {
          ...rowData.props,
          getRule: this.getRule,
          setValue: this.setValue,
        };
      }
      return rowData;
    },
    // 渲染完成后执行
    formComplete() {
      this.disabled(true, ['invoiceType']);
      const currentYear = new Date().getFullYear();
      // 限制选择活动时间
      const pickerOptions = {
        disabledDate: (time) => time.getTime() < new Date(`${currentYear}-01-01`).getTime() - 8.64e7,
      };
      const qdDate = this.getRule('qdDate');
      qdDate.props = {
        ...qdDate.props,
        pickerOptions,
      };
      const startTime = this.getRule('startTime');
      startTime.props = {
        ...startTime.props,
        pickerOptions,
      };
      const endTime = this.getRule('endTime');
      endTime.props = {
        ...endTime.props,
        pickerOptions,
      };
      console.log('formConfig——————————', this.formConfig);
      const { code, row } = this.formConfig;
      if (code === 'view' || code === 'edit') {
        console.log(1111);
        request.post('/dms/terminalcontract/query', {
          id: row.closeContractCode ? '' : row.id,
          terminalContractCode: row.closeContractCode,
        }).then((res) => {
          if (res.success) {
            let contAmount = 0;
            const { result } = res;
            if (result.details) {
              result.details.forEach((vitem) => {
                contAmount += (vitem.num * vitem.productPrice);
                console.log('contAmount', contAmount);
                console.log(this.getRule('contractTotalAmount'));
              });
            }
            if (code === 'edit') {
              if (result.invoiceType) {
                this.disabled(true, ['invoiceType']);
              } else {
                this.disabled(false, ['invoiceType']);
              }
            }
            this.setValue({
              ...result,
              contractTotalAmount: contAmount.toFixed(2),
              terminalName: { terminalName: result.terminalName, terminalCode: result.terminalCode, licenseFirmName: result.licenseFirmName },
              // cusName: { customerName: result.cusName, customerCode: result.cusCode },
            });
          }
        });
      }
    },
    parseAddress(str) {
      const primaryArray = str.split(',').map((item) => item.trim());
      return primaryArray.map((address) => {
        // 检查是否存在斜杠分隔符
        if (address.includes('/')) {
          // 拆分并过滤空值
          return address.split('/').filter(Boolean);
        }
        // 无斜杠时返回单元素数组
        return [address];
      });
    },
    submit(btn) {
      console.log(btn);
      console.log('2222');
      const params = this.getFormData();
      console.log(params);
      const pars = {
        ...params,
        terminalName: params.terminalName.terminalName,
        // cusName: params.cusName.customerName,
        zcFlag: 'N',
        id: this.formConfig.id || '',
      };
      if (!params.details) {
        this.$message.error('请选择可购商品');
        return false;
      }
      if (btn === 2) {
        pars.zcFlag = 'Y';
      }
      if (params.details && params.details.length > 0) {
        params.details.map((i) => {
          const arr = [];
          if (Array.isArray(i.saleArea)) {
            i.saleArea.map((item) => {
              arr.push(item.join('/'));
              return item;
            });
            i.saleArea = arr.join(',');
          }
          return i;
        });
      }
      console.log(params);
      if (params) {
        let path = '';
        if (this.formConfig.id) {
          path = '/dms/terminalcontract/update';
        } else {
          path = '/dms/terminalcontract/save';
        }
        request.post(path, pars).then((res) => {
          if (res.code === 200) {
            this.$message.success('操作成功！');
            this.$emit('onClose');
            this.$emit('onGetList');
          } else {
            this.$message.error(res.messge);
          }
        });
      }
    },
    // 获取分公司和编码
    getFcompany() {
      const user = Storage.l.get('userInfo') ? JSON.parse(Storage.l.get('userInfo')) : {};
      request.post('/mdm/mdmOrgController/detailBatchByOrgCodeList', [user.orgCode]).then((res) => {
        if (res.code === 200) {
          console.log('1111', res);
          this.setValue({
            principalSubCompanyName: res.result[0].ext10,
            principalSubCompanyCode: res.result[0].ext9,
          });
        } else {
          this.$message.error(res.messge);
        }
      });
    },
  },
};
